import { Program } from '@app/app/page-modules/programs/models/program.model';
import { BooleanFilter } from '@app/app/shared/models/admin/boolean-filters.model';
import { SkillsDetails } from '@app/app/shared/models/skills/skills.model';

export class LoadProgramDetails {
  static readonly type = '[Program View] Load Program Details';
  constructor(
    public programUri: string,
    public languageCode?: string,
    public playlistPath?: string,
    public isCollection?: boolean,
  ) {}
}

export class ClearProgramView {
  static readonly type = '[Program View] Clear Program View';
}

export class SetProgramViewDetails {
  static readonly type = '[Program view] Set program view details';

  constructor(public program: Program) {}
}

export class SaveProgramParticipantFilters {
  static readonly type = '[Program View] Save Participant Filters';

  constructor(public filters: BooleanFilter[]) {}
}

export class SetProgramSkills {
  static readonly type = '[Program View] Set Program Skills';

  constructor(public skills: SkillsDetails) {}
}

export class LoadProgramGoal {
  static readonly type = '[Program View] Load Program Goal';
  constructor(
    public programId: string,
    public languageCode?: string,
  ) {}
}

export class LoadProgramCertificate {
  static readonly type = '[Program View] Load Program Certificate';
  constructor(public programId: string) {}
}
